import { render, staticRenderFns } from "./TenantNotExist.vue?vue&type=template&id=58160414&scoped=true&"
var script = {}
import style0 from "./TenantNotExist.vue?vue&type=style&index=0&id=58160414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58160414",
  null
  
)

export default component.exports